import React from "react";
import { Outlet } from "react-router-dom";
import LoginWithHeader from "./component/LoginWithHeader";

function Layout() {
  return (
    <div className="wrapper">
      <div id="snackbar"></div>

      {/* Header always visible */}
      <header className="header">
        <LoginWithHeader />
      </header>

      {/* Page content */}
      <main>
        <Outlet />
      </main>
    </div>
  );
}

export default Layout;